// import type { ColumnsType } from 'antd';

export const isEmptyValue = value => {
  if (value === null || value === undefined) return true;
  if (typeof value === "string" && value.trim() === "") return true;
  if (Array.isArray(value) && value.length === 0) return true;
  if (typeof value === "object" && Object.keys(value).length === 0) return true;
  return false;
};

// export const withEmptyFallback = (columns: ColumnsType<any>) =>
//   columns.map(col => ({
//     ...col,
//     render: col.render
//       ? col.render
//       : (value: any) =>
//           value === null || value === undefined || value === "" ? "-" : value,
//   }));

// export const withFiledEmptyFallback = (value: any) =>
//   value === null || value === undefined || value === "" ? "-" : value;

// export const withBooleanEmptyFallback = (value: any, a: any, b: any): any =>{
//     if (typeof value === 'boolean') {
//         return value ? a : b;
//     } else {
//         return '-';
//     }
// }

type AnyObject = Record<string, any>;

/**
 * 递归移除对象中的指定字段
 * @param obj 原始对象（或数组）
 * @param keys 要移除的字段数组
 * @returns 新对象/数组
 */
export const deepOmit = (obj: any, keys: string[]) => {
  if (Array.isArray(obj)) {
    return obj.map(item => deepOmit(item, keys));
  }

  if (typeof obj === "object" && obj !== null) {
    const result: AnyObject = {};

    for (const key in obj) {
      if (!keys.includes(key)) {
        result[key] = deepOmit(obj[key], keys);
      }
    }

    return result;
  }

  return obj;
};
